<div id="webcamModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="onCancelClicked()">&times;</button>
        <h4 class="modal-title">{{ 'pages.createReceiptPage.oneReceipt.webcam.webcam' | translate}}</h4>
      </div>
      <div class="modal-body" >
        <webcam *ngIf="cameraActive" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                [videoOptions]="videoOptions"
                [imageQuality]="1"
                (cameraSwitched)="cameraWasSwitched($event)"
                (initError)="handleInitError($event)">

        </webcam>

        <div *ngIf="errors.length" class="alert alert-danger camera-error" role="alert">
          {{ errors[0].message }}
        </div>


        <img *ngIf="capturedImage" [src]="capturedImage" alt="Captured Image">


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onOkClicked()">{{ 'common.ok' | translate}}</button>
        <button type="button" class="btn btn-default" (click)="triggerSnapshot()">{{ 'common.capture' | translate}}</button>
        <button type="button" class="btn btn-default" data-dismiss="modal" (click)="onCancelClicked()">{{ 'common.cancel' | translate}}</button>
      </div>
    </div>
  </div>
</div>


